<template>
<div>
  <div v-if="reservationComp && isActiveComp==true && !loading" class="container">
    <h2 style="margin-bottom:0px;" class="small-h2 text-center"><i class="fa fa-list-alt"></i> Booking ID: <strong>{{reservationComp.BookingNumber}} </strong></h2>
  
      <hr style="margin-top:5px;">
    
      <div>
        <div class="hidden-lg hidden-md">
            <button @click="switchCollapse()" class="hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title" data-toggle="collapse" data-target="#summary"> <i class="fa fa fa-navicon" /> &nbsp {{summaryComp}}</button>
            
            <div class=" hidden-md hidden-lg collapse" id="summary" aria-expanded="true" style="margin-left:0px;padding-left:0px; margin-right:0px; padding-right:0px">
                
                <div class="reservationSummary">
                        <div v-for="petCard in reservationComp.AvailablePetDtos">
                    <div>
                        <PetSelectCard :showDetails='true' v-bind:petId="petCard.PetId" :key="petCard.PetId"></PetSelectCard>
                    </div>
                    </div>
                    
                    <div class="summary-desc">
                    <h5>Total Days: {{reservationComp.TotalDays}}</h5>
                    <h5>Dates: {{startDateComp}} - {{endDateComp}}</h5>
                    
                    <h5 v-for="service in reservationComp.ServicePriceSummaryDtos">{{service.Description}}</h5>
                    <h5 class="text-success">Total Price: {{reservationComp.TotalPrice}} {{currencyComp}}</h5>
                 
                    </div>
                </div>
            </div>
            <br>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-7 remove-margins">
        <div v-if="reservationComp.SitterStatus" class="alert alert-dismissible" :class="reservationComp.StatusClass" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <p><strong>Status: </strong>{{reservationComp.SitterStatus}}</p>
          </div>
          
           <div class="media-left">
                <img :src="reservationComp.CustomerProfilePic" alt="" class="media-object img-responsive img-circle" height="25" width="25"></img>
           </div>
            
           <div class="media-left head-title">
                <h4  class="media-heading " style="display:inline-block;padding-bottom:0px;margin-bottom:0px;"> {{reservationComp.CustomerName}}</h4>
          </div>
          <Chat v-if="signalReadyComp" :isSitterAccepted="reservationComp.IsSitterAccepted" :transactionId="reservationIdComp"></Chat>
          <br>
         
        <div class="buttons" v-if="!rejectedComp">
            <div class="buttons-started" v-if="notStartedComp">
                <button  class="btn btn-block btn-success" :disabled="reservationComp.IsSitterAccepted==true" @click="acceptReservation()">
                <i class="fa fa-check"></i>
                {{acceptedButton}}</button>
                <button   data-toggle="popover"  data-trigger="hover" data-placement="top"  class="btn btn-block  btn-warning" @click="rejectRequest()" >
                <i class="fa fa-trash-o"></i>
                Reject Request</button>
                <br>
            </div>
           

        </div>
        <div v-if="rejectedComp">
        <button style="margin-bottom:5px;" v-if="!reservationComp.IsSitterRemoved" class="btn btn-warning btn-block"   @click="removeDashboard()" >
            <i class="fa fa-trash-o"></i>
            Remove from Bookings</button>
        </div>

        <button class="btn btn-info btn-block btn-lg" @click="goMySitterReservations()">View all Bookings</button>
        </div>
         
        <div class="hidden-xs hidden-sm col-md-4 pull-right reservationSummary">
           <h4 class="text-center"> Summary </h4>
            
            <div v-for="petCard in reservationComp.AvailablePetDtos" :key="petCard.PetId">
              <div>
                <PetSelectCard :showDetails='true' v-bind:petId="petCard.PetId"></PetSelectCard>
              </div>
            </div>
            <br>
            <h5>Total Days: {{reservationComp.TotalDays}}</h5>
            <h5>Dates: {{startDateComp}} - {{endDateComp}}</h5>
            
            <h5 v-for="service in reservationComp.ServicePriceSummaryDtos" >{{service.Description}}</h5>
            <h5 class="text-success">Total Price: {{reservationComp.TotalPrice}} {{currencyComp}}</h5>
           
        </div>
        </div>
  </div>  <!-- closing the main container-->


  <div v-if="loading" class="container">
    <div class="text-center">
      <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
    </div>
  </div>  <!-- closing the v-else container-->
  <div v-if="isActiveComp==false">
        <br>
        <h1 class="text-center">You need to have an active membership to view this reservation</h1>
        <p class="text-center">Note: Only customers who are members can reach out to you without Premium membership</p>
        <div class="col-md-4 col-md-offset-4">
        <br>
        <button class="btn btn-block btn-premium" @click="goSubscribe()">Go Premium <i class="fa fa-paw"/></button>
        <br>
        </div>
  </div>
</div>
</template>

<script>


import auth from '../../../auth'
import store from '../../../data/store'
import PetSelectCard from '../../SharedComponents/PetSelectCard'
import Chat from '../../../components/SharedComponents/Chat'


export default {
    data () {
        return {
            existingReservation: '',
            notification:'',
            error: false,
            sending: false,
            sent: false,
            loading: true,
            blocking: '',
            selectedTime: '',
            summaryCollapse: true,
            ready: true,
            allowTimeEdit: false,
            isAccepted: false,
            errorMsg: ''
        }
    },
    components: {
        PetSelectCard,
        Chat,
        
    },
    computed: {
        isActiveComp: function(){
            if (this.reservationComp!=null)
                return this.reservationComp.IsSitterCustomerActive
        },
         currencyComp: function(){
            return store.getters.CountryData.Currency
        },
        notStartedComp: function(){
            var self=this

            var startDate = moment(self.existingReservation.StartDate)
            if (startDate.isBefore(moment(), 'day'))
                return false
            else
                return true
        },
        rejectedComp: function(){
            var self = this
            var startDate = moment(self.reservationComp.StartDate)

            if (self.reservationComp.IsSitterRejected == true || self.reservationComp.IsCustomerCancelled == true)
                return true
            else if (self.reservationComp.SitterResponseDate==null && startDate.isBefore(moment(), 'day'))
                return true
            else    
                return false
        },
        summaryComp: function(){
            if (this.summaryCollapse==true)
                return 'Hide Summary'
            else 
                return 'Show Summary'
        },
        startDateComp: function(){
            var self = this
            return moment(self.existingReservation.StartDate).format('DD MMM YYYY')
        },
        endDateComp: function(){
            var self = this
            return moment(self.existingReservation.EndDate).format('DD MMM YYYY')
        },
        reservationIdComp: function(){
            var self=this;
            if (self.$route.params!=null)
            return self.$route.params.reservationId
        },
        signalReadyComp: function(){
            if (store.getters.SignalRHub!=null && this.ready==true)
                if (store.getters.SignalRHub.connection!=null)
                    return true
            return false;

        },
        reservationComp: function(){
            var self = this
            if (self.existingReservation)
                if (self.existingReservation)
                    return self.existingReservation
        },
        reservationReadyComp: function(){
            if (this.existingReservation!=null && this.signalReadyComp==true)
                return true
            return false
        },
        senderIdComp: function(){
           if (store.getters.userRole=="Client")
                return store.getters.CustomerId
           else
                return store.getters.SitterId
        },
        signalRHubComp: function(){
            if (this.signalReadyComp)
                return store.getters.SignalRHub
        },
        acceptedButton: function(){
            if (this.existingReservation.IsSitterAccepted==false)
                return "Accept invitation"
            else 
            {
                this.isAccepted=true
                return "Accepted invitation"
            }
                
        },
        timezoneComp: function(){
            return store.getters.CountryData.CountryTimezone
        }
       
    },
    watch: {
        '$route.params.reservationId': function(){
            this.ready=false
            this.initReservation()
            this.$forceUpdate()
        },
    },
    updated: function(){
        $('[data-toggle="popover"]').popover();
        // $zopim(function (){
        // $zopim.livechat.sendVisitorPath();
        // });
        $('#summary').collapse('show');

    },
    methods: {
        goSubscribe: function(){
            var self = this
            self.$router.push({path: '/subscribe'})
            self.$router.go({path: '/subscribe'})
        },  
        dateFormatter: function(date){
            return moment(date).format('DD MMM YYYY')
        },
        goSupport(){
             this.$router.push({
                path: '/contact-support/' + '?bookingId=' + this.existingReservation.BookingNumber,
                force: true
                })
        },
        rejectRequest(){
            var self = this;

            swal({
                title: 'Rejecting Booking',
                text: "Are you sure you want to reject this booking? you will not be able to view it later",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-warning",
                confirmButtonText: 'Yes Reject',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                closeOnConfirm: true,
                closeOnCancel: true
                },
                function(isConfirm) {
                if (isConfirm==true) {
                    self.rejectReservation()            
                } else if (isConfirm==false) {
                    
                } 
            });

         
        },
        removeDashboard(){
            var self = this
            self.existingReservation.IsSitterRemoved = true
            self.signalRHubComp.invoke('UpdateReservation',self.existingReservation ,store.getters.userRole)
        },
        rejectReservation(){
            var self = this;
            self.existingReservation.IsSitterRemoved = true //remove the sitter from any future notifications of this reservation.
            self.existingReservation.IsSitterRejected = true
            self.existingReservation.SitterRejectedDate = new Date()
            if (self.existingReservation.SitterResponseDate==null)
                self.existingReservation.SitterResponseDate = new Date()
            self.signalRHubComp.invoke('UpdateReservation',self.existingReservation ,store.getters.userRole)
        },
        switchCollapse(){
            if (this.summaryCollapse==true)
                this.summaryCollapse=false
            else
                this.summaryCollapse=true
        },
        initReservation(){
        var self = this
        self.loading = true
        $.ajax("https://www.dupaws.com/services/api/sitter/getReservation/" + self.$route.params.reservationId, {
                type: 'GET',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                  self.existingReservation = data
                  self.loading = false
                  self.ready=true
                },
                error: function () {
                    self.loading = false
                    swal("Oops", "an error happened while retrieving this booking, maybe it was expired?", "warning")
                    self.$router.push({path: '/my-sitter-reservations'})        
                }
            });
        },
        goMySitterReservations: function(){
            this.$router.push({path: '/my-sitter-reservations'})
        },
        acceptReservation: function(){
            var self = this;

            swal({
                title: 'Calendar Updated',
                text: "New entry was added to your calendar, no one else can book you through those dates, if you want to change that go to Calendar and click on the entry and mark yourself as available or if you or the customer cancel this booking it will be removed automatically.",
                type: "info",
                confirmButtonClass: "btn-info",
                confirmButtonText: 'Okay, got it!',
                allowOutsideClick: false,
                closeOnConfirm: false,
                },
                function(isConfirm) {
                if (isConfirm==true) {
                    self.acceptReservationAjax(true)            
                    return;
                } 
            });
        },  
        acceptReservationAjax: function(blocking){
            
            var self = this
             $.ajax("https://www.dupaws.com/services/api/sitter/acceptReservationCalendar/" + self.existingReservation.ReservationId + "?blocking=" + blocking, {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function () {
                        self.existingReservation.IsSitterAccepted = true
                        self.updateReservation()
                                    
                        swal({
                            title: 'Excellent job',
                            text: "To get rated or reviewed on this booking, ask customer to confirm it before start date",
                            type: "success",
                            confirmButtonClass: "btn-success",
                            confirmButtonText: 'Woof!',
                            allowOutsideClick: false,
                            closeOnConfirm: true,
                            },
                            function(isConfirm) {
                                return;
                            
                            });
                        
                    },
                    error: function () {
                        console.log("Error happened at acceptReservationCalendar")
                }
            });
        },
        updateReservation: function(){
            var self = this
            this.signalRHubComp.invoke('UpdateReservation',self.existingReservation ,store.getters.userRole)
        },
         
    },
    mounted: function () {
        var self = this
        self.initReservation()
          

        self.$forceUpdate();
        
       
        store.commit('readNotificationTrans',self.reservationIdComp)

        self.signalRHubComp.on('UpdateReservation', function(reservationDto){
        if (reservationDto.ServiceTransactionId==self.existingReservation.ServiceTransactionId)
            self.existingReservation = reservationDto
        }) 
    },
   

}
 
</script>
<style scoped>

.modal {
  text-align: center;
}

 .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.reservationSummary{
    border: 1px;
    
    border-style: solid;
    border-color:#c3c3c3;
    border-radius: 5px;
    background: whitesmoke;
}

.border-style{
    border: 1px #a6adad;
    border-style: solid;
    border-radius: 5px;
    margin:5px;
    padding:5px;
}

.summary-desc{
    margin:10px;
}

.some-style{
    background-color: white;
    padding: 1px;
    border-radius: 2px;
    border: 5px #09589e;
    box-shadow: 0 0 0 2px #e0e0e0;
    
    margin-bottom:3%;
}

.text-success {
    color: #62c364;
}

.flex-item{
    margin:3px;
}

.btn-default:hover {
    color: #333;
    background-color: #ffffff;
    border-color: #a7a7a7;
}

.btn-default:focus, .btn-default.focus {
    color: #333;
    background-color: white;
    border-color: #8c8c8c;
}


.text-price{
   font-family: 'Yanone Kaffeesatz', sans-serif;
  font-weight: 600;
  font-size: 1.95em;
  color: #737574;
  padding-bottom: 0;
}

.list-flex{
    max-width:500px;
    display:flex;
    
    
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


</style>


// WEBPACK FOOTER //
// ViewSitterReservationComponent.vue?6d2d399c